var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg2DarkBullet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0F0F0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1036 16.5V15.733L12.9843 12.5795C13.3224 12.2102 13.6008 11.8892 13.8195 11.6165C14.0383 11.3409 14.2002 11.0824 14.3053 10.8409C14.4133 10.5966 14.4672 10.3409 14.4672 10.0739C14.4672 9.76705 14.3934 9.50142 14.2457 9.27699C14.1008 9.05256 13.9019 8.87926 13.6491 8.7571C13.3962 8.63494 13.1121 8.57386 12.7968 8.57386C12.4616 8.57386 12.1689 8.64347 11.9189 8.78267C11.6718 8.91903 11.48 9.1108 11.3437 9.35795C11.2101 9.60511 11.1434 9.89489 11.1434 10.2273H10.1377C10.1377 9.71591 10.2556 9.26705 10.4914 8.88068C10.7272 8.49432 11.0482 8.19318 11.4545 7.97727C11.8635 7.76136 12.3224 7.65341 12.8309 7.65341C13.3422 7.65341 13.7954 7.76136 14.1903 7.97727C14.5851 8.19318 14.8948 8.48437 15.1192 8.85085C15.3437 9.21733 15.4559 9.625 15.4559 10.0739C15.4559 10.3949 15.3976 10.7088 15.2812 11.0156C15.1675 11.3196 14.9687 11.6591 14.6846 12.0341C14.4033 12.4062 14.0127 12.8608 13.5127 13.3977L11.5525 15.4943V15.5625H15.6093V16.5H10.1036Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2DarkBullet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2-dark-bullet.88005378.svg";
export { ForwardRef as ReactComponent };